import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import axios from 'axios';
import ConfigAxios from '../../services/ConfigAxios';

export default function ModalExportExcel({ show, handleClose, objTextFind, urlBaseExport, nameFile, transformExcel }) {
  const [viewSpinner, setViewSpinner] = useState(false);
  const [filterExport, setFilterExport] = useState(objTextFind ? 1 : 0);

  useEffect(() => {
    if (!show) {
      setFilterExport(objTextFind ? 1 : 0);
    }
  }, [show, objTextFind]);

  const openInNewTab = async () => {
    setViewSpinner(true);
    try {
      const url = await getExcel(objTextFind);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nameFile);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error(error);
    } finally {
      setViewSpinner(false);
    }
  };

  const getExcel = async (objTextFind) => {
    const { NERTHUS, options } = ConfigAxios();
    options.responseType = 'blob';
    const filter = (filterExport === 1) ? objTextFind : '';
    const response = await axios.get(NERTHUS + urlBaseExport + filter, options);

    if (transformExcel) {
      try {
        const XLSX = require('xlsx');
        const data = await response.data.arrayBuffer();
        const workbook = XLSX.read(data, { type: 'array' });
        const newWorkbook = await transformExcel(workbook);
        const wbout = XLSX.write(newWorkbook || workbook, { bookType: 'xlsx', type: 'array' });
        return window.URL.createObjectURL(new Blob([wbout], { type: "application/octet-stream" }));
      } catch (e) {
        console.error("Error transforming excel:", e);
        return window.URL.createObjectURL(new Blob([response.data]));
      }
    }

    return window.URL.createObjectURL(new Blob([response.data]));
  };

  const handleChange = e => {
    const { value } = e.target;
    setFilterExport(Number(value));
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>Export as Excel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs defaultActiveKey="main" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="main" title="Selection">
            <Row className="mb-3">
              <Form>
                <div className="mb-3">
                  <Form.Check type={'radio'} id={`check-api-radio`} inline>
                    <Form.Check.Input
                      name="group1"
                      type={'radio'}
                      value={0}
                      onChange={handleChange}
                      defaultChecked={filterExport === 0} />
                    <Form.Check.Label>Download all records</Form.Check.Label>
                  </Form.Check> {'  '}  {'  '}

                  {(!objTextFind) ? '' :
                    (<Form.Check type={'radio'} id={`check-api-radio`} inline>
                      <Form.Check.Input
                        name="group1"
                        type={'radio'}
                        value={1}
                        onChange={handleChange}
                        checked={filterExport === 1} />
                      <Form.Check.Label>Downolad filtered records</Form.Check.Label>
                    </Form.Check>)
                  }
                </div>
              </Form>
            </Row>
            <div>
              {viewSpinner && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
              <hr />
              <Button className="btn btn-success" onClick={openInNewTab}>
                Download
              </Button>
              {' '}
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
}